/**
 * IMPORTS
 */
import accountsSelectors from 'src/aggregates/accounts/selectors';
import {add} from 'src/aggregates/customers/api';
import {modify} from 'src/aggregates/customers/api';
import {update} from 'src/aggregates/customers/api';
import {ContactAlreadyExistsError}
    from 'src/aggregates/customers/err/contactalreadyexistserror';
import {BLOCK_WHATSAPP_CONTACT} from 'src/aggregates/customers/mutations';
import {CREATE_CUSTOMER} from 'src/aggregates/customers/mutations';
import {REMOVE_CUSTOMER} from 'src/aggregates/customers/mutations';
import {TAG_CUSTOMER} from 'src/aggregates/customers/mutations';
import {UNBLOCK_WHATSAPP_CONTACT} from 'src/aggregates/customers/mutations';
import {UNTAG_CUSTOMER} from 'src/aggregates/customers/mutations';
import {UPDATE_CUSTOMER} from 'src/aggregates/customers/mutations';
import {FETCH_BSUID} from 'src/aggregates/customers/queries';
import {FETCH_BSUIDS_BY_UID} from 'src/aggregates/customers/queries';
import {FETCH_COMPANY_CONTACTS} from 'src/aggregates/customers/queries';
import {FETCH_CONTACT_TYPES} from 'src/aggregates/customers/queries';
import {FETCH_CUSTOMER} from 'src/aggregates/customers/queries';
import {FETCH_CUSTOMER_BY_CONTACT} from 'src/aggregates/customers/queries';
import {FETCH_CUSTOMERS} from 'src/aggregates/customers/queries';
import {FETCH_CUSTOMERS_BY_COMPANY} from 'src/aggregates/customers/queries';
import {FETCH_CUSTOMERS_BY_TAG_PAGE} from 'src/aggregates/customers/queries';
import {FETCH_CUSTOMERS_BY_TAGS} from 'src/aggregates/customers/queries';
import {FETCH_CUSTOMERS_PAGE} from 'src/aggregates/customers/queries';
import {FETCH_WHATSAPP_CONTACT} from 'src/aggregates/customers/queries';
import {FETCH_WHATSAPP_CONTACT_STATUS} from 'src/aggregates/customers/queries';
import customers from 'src/aggregates/customers/selectors';
import {load as loadTags} from 'src/aggregates/tags/api';
import {list as getTagsList} from 'src/aggregates/tags/selectors';
import {fetch} from 'src/aggregates/user/selectors';
import {getCompanyConfig} from 'src/aggregates/user/selectors';
import timeout from 'src/aggregates/utils/timeout';
import Metadata from 'src/config/Metadata';
import {logger} from 'src/logger';
import graphis from 'src/services/graphis';
import toDisplayable from 'src/utils/toDisplayable';


/**
 * TYPES
 */
import {IContact as IContactData} from 'src/aggregates/customers/graphis.d';
import {IConversisContact} from 'src/aggregates/customers/graphis.d';
import {ICustomer as ICustomerData} from 'src/aggregates/customers/graphis.d';
import {ISearchedCustomer} from 'src/aggregates/customers/graphis.d';
import {IBlockWhatsappContactResponse}
    from 'src/aggregates/customers/mutations.d';
import {IContactPatch} from 'src/aggregates/customers/mutations.d';
import {ICreateCustomerResponse} from 'src/aggregates/customers/mutations.d';
import {ICreateCustomerVariables} from 'src/aggregates/customers/mutations.d';
import {ICustomerPatch} from 'src/aggregates/customers/mutations.d';
import {IRemoveCustomerResponse} from 'src/aggregates/customers/mutations.d';
import {IRemoveCustomerVariables} from 'src/aggregates/customers/mutations.d';
import {ITagCustomerResponse} from 'src/aggregates/customers/mutations.d';
import {ITagCustomerVariables} from 'src/aggregates/customers/mutations.d';
import {IUnblockWhatsappContactResponse}
    from 'src/aggregates/customers/mutations.d';
import {IUntagCustomerResponse} from 'src/aggregates/customers/mutations.d';
import {IUntagCustomerVariables} from 'src/aggregates/customers/mutations.d';
import {IBsuid} from 'src/aggregates/customers/queries.d';
import {IContactType} from 'src/aggregates/customers/queries.d';
import {IFetchBsuidResponse} from 'src/aggregates/customers/queries.d';
import {IFetchBsuidsByUidResponse}
    from 'src/aggregates/customers/queries.d';
import {IFetchCompanyContactsResponse}
    from 'src/aggregates/customers/queries.d';
import {IFetchContactTypesResponse} from 'src/aggregates/customers/queries.d';
import {IFetchCustomerByContactResponse}
    from 'src/aggregates/customers/queries.d';
import {IFetchCustomersByCompanyResponse}
    from 'src/aggregates/customers/queries.d';
import {IFetchCustomersByTagPageResponse}
    from 'src/aggregates/customers/queries.d';
import {IFetchCustomersByTagsResponse}
    from 'src/aggregates/customers/queries.d';
import {IFetchCustomersFilters} from 'src/aggregates/customers/queries.d';
import {IFetchCustomersPageResponse} from 'src/aggregates/customers/queries.d';
import {IFetchCustomerResponse} from 'src/aggregates/customers/queries.d';
import {IFetchCustomersResponse} from 'src/aggregates/customers/queries.d';
import {IFetchWhatsappContactResponse}
    from 'src/aggregates/customers/queries.d';
import {IFetchWhatsappContactStatusResponse}
    from 'src/aggregates/customers/queries.d';
import {IWhatsappContactStatus} from 'src/aggregates/customers/queries.d';
import {IWhatsappContactStatusResponse}
    from 'src/aggregates/customers/queries.d';
import {IContact} from 'src/aggregates/customers/state.d';
import {ICustomerAgent} from 'src/aggregates/customers/state.d';
import {ICustomerTag} from 'src/aggregates/customers/state.d';
import {ICustomer} from 'src/aggregates/customers/state.d';
import {IContactNew} from 'src/aggregates/customers/utils.d';
import {IUnassociatedCustomer} from 'src/aggregates/customers/utils.d';
import {IGraphisError} from 'src/aggregates/index.d';


/**
 * CONSTANTS AND DEFINITIONS
 */
const areCopyUidAvailable: Set<string> = new Set(['Celular',
                                                  'Comercial',
                                                  'Email',
                                                  'Recado',
                                                  'Residencial',
                                                  'WhatsApp']);


const contactTypesChannelToId: Map<string, number> = new Map();
contactTypesChannelToId.set('celular', 1);
contactTypesChannelToId.set('residencial', 2);
contactTypesChannelToId.set('recado', 3);
contactTypesChannelToId.set('skype', 4);
contactTypesChannelToId.set('whatsapp', 5);
contactTypesChannelToId.set('facebook', 6);
contactTypesChannelToId.set('comercial', 7);
contactTypesChannelToId.set('email', 8);
contactTypesChannelToId.set('webchat', 9);
contactTypesChannelToId.set('instagram', 10);


const contactTypesIdToChannel: Map<number, string> = new Map();
contactTypesIdToChannel.set(1, 'Celular');
contactTypesIdToChannel.set(2, 'Residencial');
contactTypesIdToChannel.set(3, 'Recado');
contactTypesIdToChannel.set(4, 'Skype');
contactTypesIdToChannel.set(5, 'WhatsApp');
contactTypesIdToChannel.set(6, 'Facebook');
contactTypesIdToChannel.set(7, 'Comercial');
contactTypesIdToChannel.set(8, 'Email');
contactTypesIdToChannel.set(9, 'WebChat');
contactTypesIdToChannel.set(10, 'Instagram');

const CLIENTIS_ORIGIN = 'CL';
const CONTACTS_TIMEOUT = 8_000; // 8 seconds
const CONVERSIS_ORIGIN = 'CV';

const BRAZIL_COUNTRY_CODE = '55';
const WHATSAPP_SUFFIX = '@c.us';


/**
 * CODE
 */

/**
 * I add a customer from graphql data.
 *
 * :param customer: customer data
 *
 * :returns: promise with customer id or null
 */
async function addAssociatedCustomer(
    customer: ICustomerData,
): Promise<number>
{
    // get customer props
    const {agents, contacts, id, tags} = customer;

    // customer already added: return its id
    if (customers.getState().byId.has(id))
    {
        return id;
    }

    // get tags state
    const tagsState = await getTagsList();

    // check if has unloaded tags
    const hasUnloadedTag = tags?.some(tag => tagsState[tag.tag] === undefined);

    // has unloaded tag: reload tags
    if (hasUnloadedTag === true)
    {
        await loadTags();
    }

    // format contacts
    const formattedContacts = contacts.map(reduceContact);

    // add the customer
    await add(
        agents,
        formattedContacts,
        id,
        customer.name,
        false,
        customer.address1,
        customer.address2,
        customer.city,
        customer.code,
        customer.description,
        customer.document,
        customer.email,
        customer.organization,
        customer.state,
        tags,
        customer.zipcode,
    );

    // return customer id
    return id;
}


/**
 * I add a customer for an unassociated contact.
 *
 * :param channel: contact channel
 * :param contactName: contact name (on conversis)
 * :param uid: contact uid
 * :param username: contact username (whatsapp bsuid handle) if already resolved
 * :param phone: phone the bsuid is mapped to, empty if none, null if unknown
 *
 * :returns: created (or already existent) customer id
 */
async function addUnassociatedCustomer (
    channel: string,
    contactName: string,
    uid: string,
    username?: string | null,
    phone: string | null = null,
): Promise<number | string>
{
    // set customer id
    const id = `${channel}_${uid}`;

    // get contact channel id
    const type = contactTypesChannelToId.get(channel);

    // initialize the phone the bsuid is mapped to with the conversation phone
    let mappedPhone = phone ?? '';

    // contact is a whatsapp bsuid with an unknown phone: fetch the bsuid
    if (isWhatsappBsuid(channel, uid) === true && phone === null)
    {
        const bsuid = await getBsuid(channel, uid);

        // bsuid has username: set it
        username = bsuid?.username ?? username ?? undefined;

        // get the phone the bsuid is mapped to
        mappedPhone = reduceBsuidPhone(bsuid);
    }

    // reduce info to a contact
    const reduced: IContact = {
        displayName: getContactDisplayName(channel, uid, username),
        id,
        name: contactName,
        type_id: type,
        username,
        value: uid,
    };

    // bsuid is mapped to a phone: look for the card of the phone on the store
    if (mappedPhone !== '')
    {
        // get the alternative variant of the phone
        const alternative = getAlternativeWhatsappUid(mappedPhone);

        // get the customer of the phone
        let holder = customers.getCustomerByContact(type, mappedPhone);

        // phone has no card and has an alternative variant: get its customer
        if (holder === null && alternative !== null)
        {
            holder = customers.getCustomerByContact(type, alternative);
        }

        // the phone has an unassociated card: add the bsuid to it
        if (holder !== null && holder.unassociated === true)
        {
            await addContactToCustomer(holder.id, reduced);
            return holder.id;
        }
    }

    // customer already added: return its id
    if (customers.getState().byId.has(id) === true)
    {
        return id;
    }

    // get unassociated customer name
    const name = getUnassociatedCustomerName(channel,
                                             uid,
                                             username);

    // add customer
    await add([], [reduced], reduced.id, name, true);

    // return created customer id
    return reduced.id;
}


/**
 * I add a contact to an unassociated customer on the store.
 *
 * :param id: customer id
 * :param contact: contact to be added
 *
 * :returns: promise with the id of the customer holding the contact: the
 *           given one, or the own card of the contact when the customer is
 *           associated
 */
async function addContactToCustomer (
    id: number | string,
    contact: IContact,
): Promise<number | string>
{
    // get the customer from the store
    const customer = customers.fetch(id);

    // customer is not in the store: return its id
    if (customer === undefined)
    {
        return id;
    }

    // customer already has the contact: return its id
    if (customer.contacts.some(
        held => held.value === contact.value) === true)
    {
        return id;
    }

    // customer is associated: return the own card id of the contact
    if (customer.unassociated === false)
    {
        return contact.id;
    }

    // add the customer again with the contact
    await add(
        customer.agents,
        [...customer.contacts, contact],
        id,
        customer.name,
        true,
        customer.address1,
        customer.address2,
        customer.city,
        customer.code,
        customer.description,
        customer.document,
        customer.email,
        customer.organization,
        customer.state,
        customer.tags,
        customer.zipcode,
    );

    // return the customer id
    return id;
}


/**
 * I blocking a whatsapp contact.
 *
 * :param account: whatsapp account uid
 * :param contactUid: contact uid
 *
 * :returns: valid whatsapp contact or null
 */
async function blockWhatsappContact(
    account: string,
    contact: string,
): Promise<string | null>
{
    // initialize response
    let response: IBlockWhatsappContactResponse;

    // try block whatsapp contact
    try
    {
        response = await graphis.mutate(
            BLOCK_WHATSAPP_CONTACT,
            {account, contact},
        );
    }

    // block contact failed: log and fail with unknown reason
    catch (error)
    {
        // get user info
        const {company, id: user} = fetch();

        // log and return unknown reason
        logger.error('CVJPZ0067E', {
            company,
            contact,
            reason: error,
            user,
        });
        return 'unknown';
    }

    // get response data props
    const {blockWhatsappContact} = response.data;

    // success: return null
    if (blockWhatsappContact?.__typename === 'BlockWhatsappContact')
    {
        return null;
    }

    // fail with graphis error: return it or fallback
    return (blockWhatsappContact as IGraphisError)?.code ?? 'unknown';
}


/**
 * I get a whatsapp contact given a supposed one.
 *
 * :param contactUid: contact uid
 *
 * :returns: valid whatsapp contact or null
 */
async function checkWhatsappContact (contactUid: string): Promise<string | null>
{
    // get all whatsapp accounts
    const whatsappAccounts = accountsSelectors.getAllByChannel('whatsapp');

    // whatsapp: update contact value
    for (const account of whatsappAccounts)
    {
        // get uid value
        const uid = await getWhatsappContact(account.uid, contactUid);

        // found uid value: break loop
        if (uid !== null)
        {
            return uid;
        }
    }

    // not whatsapp: return null
    return null;
}


/**
 * I check if a contact uid is copyable.
 *
 * :param channel: channel name
 *
 * :returns: whether channel is copyable or not
 */
function copyUidAvailable (channel: string): boolean
{
    return areCopyUidAvailable.has(channel);
}


/*
 * I request to create a customer.
 *
 * :param company: customer company
 * :param name: customer name
 * :param contacts: customer contacts
 * :param address1: customer address1
 * :param address2: customer address2
 * :param city: customer city
 * :param organization: customer organization
 * :param state: customer state
 * :param zipcode: customer zipcode
 *
 * :returns: promise with customer
 */
const createCustomer = async (
    company: number,
    name: string,
    contacts: IContact[],
    address1?: string,
    address2?: string,
    city?: string,
    code?: string,
    description?: string,
    document?: string,
    organization?: string,
    state?: string,
    zipcode?: string,
): Promise<ICustomer | null> =>
{
    // convert contacts format from CRM to Graphis input
    const inputContacts = contacts.map(reduceContactNew);

    // set mutation variables
    const variables: ICreateCustomerVariables = {
        input: {
            address1,
            address2,
            city,
            code,
            company,
            contacts: inputContacts,
            description,
            document,
            email: undefined,
            name,
            organization,
            state,
            zipcode,
        },
    };

    // initialize response
    let response: ICreateCustomerResponse;

    // create customer
    try
    {
        response = await graphis.mutate(CREATE_CUSTOMER, variables);
    }

    // customer creation failed: log error and return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // get response customer
    const customer = response.data.createCustomer;

    // failed request: return null
    if (customer === null)
    {
        return null;
    }

    // convert contacts back to CRM format
    const crmContacts = customer.contacts.map(reduceContact);

    // return customer
    return {
        address1: customer.address1,
        address2: customer.address2,
        agents: customer.agents,
        calls: {},
        city: customer.city,
        code: customer.code,
        company: customer.company,
        contacts: crmContacts,
        description: customer.description,
        document: customer.document,
        id: customer.id,
        name: customer.name,
        organization: customer.organization,
        state: customer.state,
        tags: [],
        unassociated: false,
        zipcode: customer.zipcode,
    };
};


/**
 * I ensure the customer is on store.
 *
 * :param channel: contact channel
 * :param contactName: contact name (on conversis)
 * :param contactUid: contact uid
 * :param associateAlternative: whether to associate alternative contact or not
 * :param username: contact username (whatsapp bsuid handle) if already resolved
 * :param phone: phone the bsuid is mapped to, empty if none, null if unknown
 *
 * :returns: promise with customer id or null
 */
async function ensureCustomer (
    channel: string,
    contactName: string,
    contactUid: string,
    associateAlternative = false,
    username?: string | null,
    phone?: string | null,
): Promise<number | string>
{
    // get contact channel id
    const type = contactTypesChannelToId.get(channel);

    // initialize possible uids
    const uids: string[] = [contactUid];

    // association is allowed and channel is whatsapp: check the need for an
    // alternative uid
    if (associateAlternative === true && channel === 'whatsapp')
    {
        // get alternative uid
        const alternativeUid = getAlternativeWhatsappUid(contactUid);

        // alternative uid found: add it to possible uids
        if (alternativeUid !== null)
        {
            uids.push(alternativeUid);
        }
    }

    // try to get the id from the customer that has the original uid
    for (const uid of uids)
    {
        // get customer from state
        const customer = customers.getCustomerByContact(type, uid);

        // customer exists: check which contact it has
        if (customer !== null)
        {
            // customer has the original uid: return customer id
            if (uid === contactUid)
            {
                return customer.id;
            }

            // reduce contacts
            const contacts = handleWhatsappMismatch(
                customer.contacts,
                contactUid,
                username,
            );

            // update customer
            await update(
                Number(customer.id),
                customer.address1,
                customer.address2,
                customer.agents.map(agent => agent.uid),
                customer.city,
                customer.code,
                customer.company,
                contacts,
                customer.document,
                customer.name,
                customer.description,
                customer.organization,
                customer.state,
                customer.zipcode,
            );

            // return customer id
            return customer.id;
        }

        // customer not in store: try to fetch it from database
        const customerData = await fetchCustomerByContact(channel, uid);

        // customer found in database: add or update it in store
        if (customerData !== null)
        {
            // get customer
            const customer = customers.fetch(customerData.id);

            // customer exists in store: update its contacts
            if (customer !== undefined)
            {
                // current uid is the original one: add it to customer in store
                if (uid === contactUid)
                {
                    await modify(
                        customerData.address1,
                        customerData.address2,
                        customerData.agents,
                        customerData.city,
                        customerData.code,
                        customerData.contacts.map(reduceContact),
                        customerData.description,
                        customerData.document,
                        customerData.id,
                        customerData.name,
                        customerData.organization,
                        customerData.state,
                        customerData.zipcode,
                    );
                }

                // current uid is the alternative one: add it to customer in
                // store and database
                else
                {
                    // reduce contacts
                    const contacts = handleWhatsappMismatch(
                        customerData.contacts.map(reduceContact),
                        contactUid,
                        username,
                    );

                    // update customer
                    await update(
                        Number(customerData.id),
                        customerData.address1,
                        customerData.address2,
                        customerData.agents.map(agent => agent.uid),
                        customerData.city,
                        customerData.code,
                        customerData.company,
                        contacts,
                        customerData.document,
                        customerData.name,
                        customerData.description,
                        customerData.organization,
                        customerData.state,
                        customerData.zipcode,
                    );
                }

                // return customer id
                return customer.id;
            }

            // customer is fetched and visible: add it and return its id
            if (isCustomerVisible(customerData.agents) === true)
            {
                // initialize contacts
                let contacts = [];

                // current uid is the alternative one: transform the alternative
                // contact into a cellphone number and add the original one
                if (uid !== contactUid)
                {
                    contacts = handleWhatsappMismatch(
                        customerData.contacts.map(reduceContact),
                        contactUid,
                        username,
                    );
                }

                // add customer and get its id
                const id = await addAssociatedCustomer(customerData);

                // current uid is the alternative one: add it to customer in
                // store and database
                if (uid !== contactUid)
                {
                    await update(
                        Number(customerData.id),
                        customerData.address1,
                        customerData.address2,
                        customerData.agents.map(agent => agent.uid),
                        customerData.city,
                        customerData.code,
                        customerData.company,
                        contacts,
                        customerData.document,
                        customerData.name,
                        customerData.description,
                        customerData.organization,
                        customerData.state,
                        customerData.zipcode,
                    );
                }

                // return customer id
                return id;
            }
        }
    }

    // not associated or invisible customer: add it as unassociated
    return addUnassociatedCustomer(channel,
                                   contactName,
                                   contactUid,
                                   username,
                                   phone);
}


/**
 * I ensure the searched customer is on store
 *
 * :param term: term to search
 *
 * :returns: promise with nothing
 */
async function searchConversationContacts (
    term: string,
): Promise<void>
{
    // get search limit from metadata
    const {limit} = Metadata.config.customerSearch;

    // get contacts list
    const contacts = await searchContacts(term, limit);

    // contacts not exist: return
    if (contacts === null)
    {
        return;
    }

    // ensure there is a customer for each searched contact
    for (const {channel, uid} of contacts)
    {
        await ensureCustomer(channel, getContactDisplayName(channel, uid), uid);
    }
}


/**
 * I ensure the given contact doesn't exist.
 *
 * :param contacts: contacts list
 * :param customerId: customer id
 *
 * :returns: promise with nothing
 */
async function ensureUniqueContact (
    contacts: IContactPatch[],
    customerId: string | number | null,
): Promise<void>
{
    for (const {channel, uid} of contacts)
    {
        // get whatsapp contact variations, if whatsapp
        const reducedContacts = getContactsFromPhone(channel, uid);

        // throw an error if a variation already exists
        for (const {type_id, value: uid} of reducedContacts)
        {
            // get variation channel
            const channel = contactTypesIdToChannel.get(type_id)?.toLowerCase();

            // get id from customer with contact
            const customer = await fetchCustomerByContact(channel, uid);

            // customer exists: throw contact already exists error
            if (customer?.id !== undefined && customer.id !== customerId)
            {
                logger.error('CVJPZ0052E', {
                    channel,
                    company: fetch()?.company,
                    contact: uid,
                    customer: customer.id,
                    name: customer.name,
                    user: fetch()?.id,
                });
                throw new ContactAlreadyExistsError(
                    channel,
                    customer.id,
                    customer.name,
                    uid,
                );
            }
        }
    }
}


/**
 * I create a 9-digit whatsapp uid based on an 8-digit one.
 *
 * :param uid: contact uid
 *
 * :returns: alternative whatsapp uid or null
 */
function getAlternativeWhatsappUid (uid: string): string | null
{
    // uid is not a phone: return null
    if (uid.endsWith(WHATSAPP_SUFFIX) !== true)
    {
        return null;
    }

    // get array of uid's digits
    const digits = uid.match(/[0-9]/g);

    // uid is not a brazilian 8-digit cellphone number: return null
    if (digits.join('').startsWith(BRAZIL_COUNTRY_CODE) !== true ||
        digits.length !== 12 ||
        Number(digits[4]) <= 5)
    {
        return null;
    }

    // uid is correct: add the 9th-digit and return formatted uid
    digits.splice(4, 0, '9');
    return digits.join('') + WHATSAPP_SUFFIX;
}


/**
 * I search contacts from a company.
 *
 * :param term: term to be searched
 * :param limit: maximum number of contacts to search
 *
 * :returns: promise with contacts
 */
async function searchContacts (
    term: string,
    limit: number,
): Promise<IConversisContact[] | null>
{
    // initialize response
    let response: IFetchCompanyContactsResponse;

    // fetch company contacts
    try
    {
        response = await graphis.query(
            FETCH_COMPANY_CONTACTS,
            {limit: limit, search: term},
        );
    }

    // load company contacts failed: log and return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // return company contacts
    return response.data.companyContacts;
}


/**
 * I get a whatsapp contact possible variations.
 *
 * :param channel: contact channel type
 * :param uid: contact uid
 *
 * :returns: array of new contacts
 */
function getContactsFromPhone (channel: string, uid: string): IContactNew[]
{
    // get contact type_id
    const type_id = contactTypesChannelToId.get(channel);

    // initialize contact possible variations
    const variations: IContactNew[] = [{type_id, value: uid}];

    // not a whatsapp contact: return it unchanged
    if (channel !== 'whatsapp')
    {
        return variations;
    }

    // uid is not a phone: return it unchanged
    if (uid?.endsWith('@c.us') !== true)
    {
        return variations;
    }

    // it's a whatsapp contact: get raw alternative uid
    const alternativeUid =
        getEightDigitWhatsappUid(uid) ?? getAlternativeWhatsappUid(uid);

    // set cleansed original uid
    const cleansedOriginalUid = uid?.replace(/^55/, '')?.replace('@c.us', '');

    // set cleansed alternative uid
    const cleansedAlternativeUid =
        alternativeUid?.replace(/^55/, '')?.replace('@c.us', '');

    // add original uid variations
    variations.push({
        type_id: contactTypesChannelToId.get('celular'),
        value: cleansedOriginalUid,
    });
    variations.push({
        type_id: contactTypesChannelToId.get('comercial'),
        value: cleansedOriginalUid,
    });
    variations.push({
        type_id: contactTypesChannelToId.get('residencial'),
        value: cleansedOriginalUid,
    });

    // alternative uid found: add its variations
    if (alternativeUid !== null)
    {
        variations.push({type_id, value: alternativeUid});
        variations.push({
            type_id: contactTypesChannelToId.get('celular'),
            value: cleansedAlternativeUid,
        });
        variations.push({
            type_id: contactTypesChannelToId.get('comercial'),
            value: cleansedAlternativeUid,
        });
        variations.push({
            type_id: contactTypesChannelToId.get('residencial'),
            value: cleansedAlternativeUid,
        });
    }

    // return all possible variations
    return variations;
}


/**
 * I get all contact types.
 *
 * :returns: promise with contact types
 */
async function getContactTypes (): Promise<IContactType[] | null>
{
    // initialize response
    let response: IFetchContactTypesResponse;

    // fetch contact types
    try
    {
        response = await graphis.query(FETCH_CONTACT_TYPES);
    }

    // contact types fetch failed: log and return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // return contact types
    return response.data.contactTypes;
}


/**
 * I get a customer by id.
 *
 * :param id: customer id
 *
 * :returns: promise with customer or null
 */
async function getCustomer (id: number): Promise<ICustomerData | null>
{
    // set response
    let response: IFetchCustomerResponse;

    // load customer
    try
    {
        response = await graphis.query(FETCH_CUSTOMER, {id});
    }

    // load customer failed: log and return null
    catch (e)
    {
        logger.error('CVJPZ0024E', {id});
        return null;
    }

    // return customer
    return response.data.customer;
}


/**
 * I reduce a bsuid to its phone.
 *
 * :param bsuid: fetched bsuid
 *
 * :returns: phone uid, or empty string when the bsuid has none
 */
function reduceBsuidPhone (bsuid: IBsuid | null): string
{
    // get the bsuid uid
    const uid = bsuid?.uid ?? '';

    // uid is not a phone: return no phone
    if (uid.endsWith(WHATSAPP_SUFFIX) === false)
    {
        return '';
    }

    // return the phone
    return uid;
}


/**
 * I get a bsuid.
 *
 * :param channel: contact channel
 * :param uid: contact bsuid
 *
 * :returns: promise with the bsuid or null
 */
async function getBsuid (
    channel: string,
    uid: string,
): Promise<IBsuid | null>
{
    // get user data
    const {company, id: user, name} = fetch();

    // try fetch the bsuid: any failure must not break customer creation
    try
    {
        // fetch bsuid
        const response: IFetchBsuidResponse = await graphis.query(
            FETCH_BSUID,
            {channel, uid},
        );

        // return the bsuid
        return response.data.bsuid;
    }

    // cannot fetch: log error and return null
    catch (error)
    {
        logger.error('CVJPZ0104E', {
            company,
            name,
            reason: error.message,
            user,
        });
        return null;
    }
}


/**
 * I get the bsuids mapped to the given contact uids.
 *
 * :param channel: contacts channel
 * :param uids: contacts uids
 *
 * :returns: promise with the found bsuids
 */
async function getBsuidsByUid (
    channel: string,
    uids: string[],
): Promise<IBsuid[]>
{
    // get user data
    const {company, id: user, name} = fetch();

    // try fetch the bsuids: any failure must not break the customer
    try
    {
        // fetch bsuids
        const response: IFetchBsuidsByUidResponse = await graphis.query(
            FETCH_BSUIDS_BY_UID,
            {channel, uids},
        );

        // return the bsuids
        return response.data.bsuidsByUid;
    }

    // cannot fetch: log error and return no bsuid
    catch (error)
    {
        logger.error('CVJPZ0105E', {
            company,
            name,
            reason: error.message,
            user,
        });
        return [];
    }
}


/**
 * I get a whatsapp phone and its brazilian 9th-digit variants.
 *
 * :param phone: phone uid
 *
 * :returns: phone with its variants
 */
function getPhoneVariants (phone: string): string[]
{
    // get the variants of the phone
    const variants = [
        getAlternativeWhatsappUid(phone),
        getEightDigitWhatsappUid(phone),
    ];

    // return the phone with the variants it has
    return [phone, ...variants.filter(variant => variant !== null)];
}


/**
 * I get the other whatsapp uids a contact is known by through the bsuid
 * mapping.
 *
 * :param typeId: contact type id
 * :param uid: contact uid, a bsuid or a phone
 *
 * :returns: promise with the phone mapped to a bsuid, or with the bsuids
 *           mapped to a phone
 */
async function getMappedContactUids (
    typeId: number,
    uid: string,
): Promise<string[]>
{
    // contact is not a whatsapp one: return no uids
    if (typeId !== contactTypesChannelToId.get('whatsapp'))
    {
        return [];
    }

    // contact is a bsuid: return the phone mapped to it, if any
    if (isWhatsappBsuid('whatsapp', uid) === true)
    {
        const mapping = await getBsuid('whatsapp', uid);

        // bsuid maps no phone: return no uids
        if (mapping === null || mapping.uid === null)
        {
            return [];
        }

        // return the mapped phone with its variants
        return getPhoneVariants(mapping.uid);
    }

    // get the bsuids mapped to the phone or to one of its variants
    const mappings = await getBsuidsByUid('whatsapp', getPhoneVariants(uid));

    // return the mapped bsuids
    return mappings.map(mapping => mapping.bsuid);
}


/**
 * I join the card of a bsuid to the customer that holds the bsuid.
 *
 * :param id: customer id
 *
 * :returns: promise with the id of the customer that ends up holding the
 *           bsuid
 */
async function mergeMappedContacts (
    id: ICustomer['id'],
): Promise<ICustomer['id']>
{
    // get the customer from the store
    const customer = customers.fetch(id);

    // customer is not in the store: return its id
    if (customer === undefined)
    {
        return id;
    }

    // get the whatsapp type id and the first contact of the customer
    const type = contactTypesChannelToId.get('whatsapp');
    const [contact] = customer.contacts;

    // customer is not an unassociated card of a bsuid alone: return its id
    if (customer.unassociated === false || customer.contacts.length !== 1 ||
        contact.type_id !== type ||
        isWhatsappBsuid('whatsapp', contact.value) === false)
    {
        return id;
    }

    // get the customer holding the bsuid on clientis
    const data = await fetchCustomerByContact('whatsapp', contact.value);

    // clientis holds no customer with the bsuid: join the card on the store
    if (data === null)
    {
        return addUnassociatedCustomer('whatsapp',
                                       contact.name,
                                       contact.value,
                                       contact.username);
    }

    // add the customer holding the bsuid, replacing its copy on the store
    await add(
        data.agents,
        data.contacts.map(reduceContact),
        data.id,
        data.name,
        false,
        data.address1,
        data.address2,
        data.city,
        data.code,
        data.description,
        data.document,
        data.email,
        data.organization,
        data.state,
        data.tags,
        data.zipcode,
    );

    // return the customer id
    return data.id;
}


/**
 * I make the bsuids follow the whatsapp phones an update adds to or removes
 * from a customer.
 *
 * :param oldContacts: contacts the customer holds on the store
 * :param contacts: contacts the update sends
 *
 * :returns: promise with the contacts with the bsuids following their phones,
 *           and the added phone each pulled bsuid is mapped to
 */
async function syncBsuidsWithPhones (
    oldContacts: IContact[],
    contacts: IContactPatch[],
): Promise<{contacts: IContactPatch[]; phonesByBsuid: Map<string, string>}>
{
    // get the whatsapp type id
    const whatsapp = contactTypesChannelToId.get('whatsapp');

    // get the phones the customer holds and the phones the update sends
    const oldPhones = oldContacts
        .filter(contact => contact.type_id === whatsapp &&
                contact.value.endsWith(WHATSAPP_SUFFIX) === true)
        .map(contact => contact.value);
    const newPhones = contacts
        .filter(contact => contact.channel === 'whatsapp' &&
                contact.uid.endsWith(WHATSAPP_SUFFIX) === true)
        .map(contact => contact.uid);

    // get the variants of both, so a 9th digit swap counts as the same phone
    const oldVariants = oldPhones.flatMap(getPhoneVariants);
    const newVariants = newPhones.flatMap(getPhoneVariants);

    // get the phones the update removes and adds, variants included
    const removed = oldPhones
        .filter(phone => newVariants.includes(phone) === false)
        .flatMap(getPhoneVariants);
    const addedPhones = newPhones
        .filter(phone => oldVariants.includes(phone) === false);
    const added = addedPhones.flatMap(getPhoneVariants);

    // no phone changed: return the contacts as they are
    if (removed.length === 0 && added.length === 0)
    {
        return {contacts, phonesByBsuid: new Map()};
    }

    // get the bsuids mapped to the changed phones
    const mappings = await getBsuidsByUid('whatsapp', [...removed, ...added]);

    // get the bsuids of the removed phones
    const dropped = mappings
        .filter(mapping => removed.includes(mapping.uid ?? '') === true)
        .map(mapping => mapping.bsuid);

    // get the mappings of the added phones
    const pulledMappings = mappings
        .filter(mapping => added.includes(mapping.uid ?? '') === true);

    // get the bsuids of the added phones
    const pulled = pulledMappings.map(mapping => mapping.bsuid);

    // drop the bsuids of the removed phones
    const kept = contacts.filter(contact => contact.channel !== 'whatsapp' ||
                                 dropped.includes(contact.uid) === false);

    // add the bsuids of the added phones the customer does not hold yet
    const missing = [...new Set(pulled)]
        .filter(bsuid => kept.some(contact => contact.uid === bsuid) === false)
        .map(bsuid => ({channel: 'whatsapp', uid: bsuid}));

    // get the added phone each pulled bsuid is mapped to, as the update sent it
    const phonesByBsuid = new Map<string, string>(pulledMappings.map(
        ({bsuid, uid}) => [bsuid, addedPhones.find(phone =>
            getPhoneVariants(phone).includes(uid ?? '') === true) ?? '']));

    // return the contacts with the bsuids following their phones
    return {contacts: [...kept, ...missing], phonesByBsuid};
}


/**
 * I get customers by contact.
 *
 * :param channel: contact channel
 * :param uid: contact uid
 *
 * :returns: promise with customer or null
 */
async function fetchCustomerByContact(
    channel: string,
    uid: string,
): Promise<ICustomerData | null>
{
    // get user and company
    const {company, id} = fetch();

    // try fetch the customer
    try
    {
        // fetch customer
        const response: IFetchCustomerByContactResponse = await graphis.query(
            FETCH_CUSTOMER_BY_CONTACT,
            {channel, company, uid},
        );

        // return founded customer
        return response.data.customerByContact;
    }

    // cannot fetch: log error and return null
    catch (error)
    {
        logger.error('CVJPZ0035E', {
            channel,
            company,
            contact: uid,
            reason: error,
            user: id,
        });
        return null;
    }
}


/**
 * I get customers with given filters.
 *
 * :param company: company id
 * :param page: page number
 * :param size: page size
 * :param filter: filter
 *
 * :returns: promise with customers
 */
const getCustomers = async (
    company: number,
    page: number,
    size: number,
    filter?: string,
): Promise<ISearchedCustomer[] | null> =>
{
    // set filters
    const filters: IFetchCustomersFilters = {company, limit: size, page};

    // has filter: set it in params
    if (filter !== undefined)
    {
        filters.q = filter;
    }

    // initialize response
    let response: IFetchCustomersResponse;

    // fetch customers
    try
    {
        response = await graphis.query(FETCH_CUSTOMERS, {filters});
    }

    // load customers failed: log and return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // return customers
    return response.data.customers;
};


/**
 * I get customers of the given company.
 *
 * :param company: company id
 *
 * :returns: promise with customers
 */
const getCustomersByCompany = async (
    company: number,
): Promise<ICustomerData[] | null> =>
{
    // initialize response
    let response: IFetchCustomersByCompanyResponse;

    // fetch customers
    try
    {
        response = await graphis.query(FETCH_CUSTOMERS_BY_COMPANY, {company});
    }

    // load customers failed: log and return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // return customers
    return response.data.customersByCompany;
};


/**
 * I get customers by tag with pagination.
 *
 * :param tag: tag id
 * :param page: page number
 * :param size: customers by page
 *
 * :returns: promise with customers ids or null
 */
const getCustomersByTagPage = async (
    tag: number,
    page: number,
    size?: number,
): Promise<number[] | null> =>
{
    // get user data
    const {company, id: user, name} = fetch();

    // try get customers
    try
    {
        // fetch customers
        const response: IFetchCustomersByTagPageResponse = await graphis.query(
            FETCH_CUSTOMERS_BY_TAG_PAGE,
            {page, size, tag},
        );

        // return customers
        return response.data.customers;
    }

    // failed: log and return null
    catch (error)
    {
        logger.error('CVJPZ0096E', {
            company,
            name,
            page,
            reason: error,
            tag,
            user,
        });
        return null;
    }
};


/**
 * I get customers by tags.
 *
 * :param tags: tags to filter
 *
 * :returns: promise with customers or null
 */
const getCustomersByTags = async (
    tags: number[],
): Promise<ICustomerData[] | null> =>
{
    // get user and company
    const {id, company} = fetch();

    // try get customers by tags
    try
    {
        // get customers
        const response: IFetchCustomersByTagsResponse = await graphis.query(
            FETCH_CUSTOMERS_BY_TAGS,
            {company, tags},
        );

        // return customers
        return response.data.customersByTags;
    }

    // load customers failed: log and return null
    catch (error)
    {
        logger.error('CVJPZ0037E', {
            company,
            reason: error,
            user: id,
        });
        return null;
    }
};


/**
 * I get customers page
 *
 * :param page: page to load
 * :param size: page size
 *
 * :returns: nothing
 */
async function getCustomersPage (
    page: number,
    size?: number,
): Promise<ICustomerData[] | null>
{
    // get user and company
    const {id, company} = fetch();

    // try to get customers page
    try
    {
        // get customers page
        const response: IFetchCustomersPageResponse = await graphis.query(
            FETCH_CUSTOMERS_PAGE,
            {company, page, size},
        );

        // return customers
        return response.data.customersPage;
    }

    // failed to get page: log error and return null
    catch (error)
    {
        logger.error('CVJPZ0036E', {
            company,
            page,
            reason: error,
            user: id,
        });
        return null;
    }
}


/**
 * I create an 8-digit whatsapp uid based on a 9-digit one.
 *
 * :param uid: contact uid
 *
 * :returns: 8-digit whatsapp uid or null
 */
function getEightDigitWhatsappUid (uid: string): string | null
{
    // uid is not a phone: return null
    if (uid.endsWith(WHATSAPP_SUFFIX) !== true)
    {
        return null;
    }

    // set array of uid's digits
    const digits = uid.match(/[0-9]/g);

    // uid is not a brazilian 9-digit cellphone number: return null
    if (digits.join('').startsWith(BRAZIL_COUNTRY_CODE) !== true ||
        digits.length !== 13 ||
        Number(digits[5]) <= 5)
    {
        return null;
    }

    // uid is 9-digit: remove the 9th-digit and return formatted uid
    digits.splice(4, 1);
    return digits.join('') + WHATSAPP_SUFFIX;
}


/**
 * I get the display name for a contact.
 *
 * :param channel: contact channel
 * :param uid: contact uid
 * :param username: contact username (whatsapp bsuid handle)
 *
 * :returns: contact display name
 */
function getContactDisplayName (
    channel: string,
    uid: string,
    username: string | null = '',
): string
{
    // channel is not whatsapp: return uid as is
    if (channel !== 'whatsapp')
    {
        return uid;
    }

    // uid is a phone: return the phone number
    if (uid?.endsWith('@c.us') === true)
    {
        return toDisplayable('whatsapp', uid);
    }

    // uid is a bsuid with username: return the handle
    if (username !== null && username !== '')
    {
        return `@${username}`;
    }

    // bsuid without username: return the raw uid
    return uid;
}


/**
 * I get an unassociated customer name.
 *
 * :param channel: contact channel
 * :param uid: contact uid
 * :param username: contact username (whatsapp bsuid handle)
 *
 * :returns: unassociated customer name
 */
function getUnassociatedCustomerName (
    channel: string,
    uid: string,
    username?: string | null,
): string
{
    // channel is email: return contact uid
    if (channel === 'email')
    {
        return uid;
    }

    // channel is whatsapp: return the contact display name
    if (channel === 'whatsapp')
    {
        return getContactDisplayName('whatsapp', uid, username);
    }

    // other channel: set default name
    let name = `${channel} não cadastrado`.trim();

    // set first letter to uppercase
    name = name[0].toUpperCase() + name.slice(1);

    // has an uid: concat it to name
    if (uid !== undefined)
    {
        name = `${name} - ${uid}`;
    }

    // return unassociated customer name
    return name;
}


/**
 * I get unassociated customers that have to be added.
 *
 * :param contacts: contacts that if none customer has one, it needs to be added
 *
 * :returns: promise with array of customer
 */
async function getUnassociatedCustomersToBeAdded (
    contacts: IContact[],
): Promise<IUnassociatedCustomer[]>
{
    // initialize array of unassociated customers to be added
    const customersToAdd: IUnassociatedCustomer[] = [];

    // get logged user company
    const company = fetch().company;

    // get account active channels
    const channels = accountsSelectors.getChannels();

    // create unassociated customer for each contact
    for (const contact of contacts)
    {
        // contact is not from active channel: skip it
        if (isActive(contact.type_id, channels) === false)
        {
            continue;
        }

        // contact is active: check if contact exists in any other customer
        const customer = customers.getCustomersByContact(contact.type_id,
                                                         contact.value);

        // contact exist only on the customer being removed: create new customer
        if (customer.length === 1)
        {
            // reduce contact to an unassociated one
            const type_id = contact.type_id;
            const uid = contact.value;
            const contactName = contact.name;
            const username = contact.username;
            const channel = contactTypesIdToChannel.get(type_id).toLowerCase();
            const reduced: IContact = {
                displayName: getContactDisplayName(channel, uid, username),
                id: `${channel}_${uid}`,
                name: contactName,
                type_id,
                username,
                value: uid,
            };

            // get unassociated customer name
            const name = getUnassociatedCustomerName(channel,
                                                     uid,
                                                     username);

            // add created customer to return array
            customersToAdd.push({
                agents: [],
                company,
                contacts: [reduced],
                id: reduced.id,
                name,
                unassociated: true,
            });
        }
    }

    // move each bsuid to the customer of the phone it is mapped to
    for (const customer of [...customersToAdd])
    {
        // get the contact of the customer
        const contact = customer.contacts[0];

        // contact is not a bsuid: it leads its own customer
        if (isWhatsappBsuid(
            contactTypesIdToChannel.get(contact.type_id).toLowerCase(),
            contact.value) === false)
        {
            continue;
        }

        // get the uids the bsuid is known by
        const mapped = await getMappedContactUids(contact.type_id,
                                                  contact.value);

        // get the customer of a mapped uid
        const owner = customersToAdd.find(held => held.contacts.some(
            contact => mapped.includes(contact.value)));

        // bsuid maps no customer being added: keep its own customer
        if (owner === undefined)
        {
            continue;
        }

        // hand the bsuid over to the customer of the mapped phone
        owner.contacts.push(contact);
        customersToAdd.splice(customersToAdd.indexOf(customer), 1);
    }

    // return unassociated customers that need to be added
    return customersToAdd;
}


/**
 * I get unassociated customers ids whose contacts are all in an array.
 *
 * :param contacts: contacts that if a customer has all, it needs to be removed
 *
 * :returns: array of customer ids
 */
function getUnassociatedCustomersToBeRemoved (
    contacts: IContact[],
): (number | string)[]
{
    // find contacts that exists in unassociated customers
    const idsToRemove: (number | string)[] = [];
    for (const contact of contacts)
    {
        // get customer with the contact
        const customer = customers.getCustomerByContact(contact.type_id,
                                                        contact.value);

        // unassociated customer holds only given contacts: remove it
        if (customer !== null && customer.unassociated === true &&
            idsToRemove.includes(customer.id) === false &&
            customer.contacts.every(held => contacts.some(
                given => given.value === held.value)) === true)
        {
            idsToRemove.push(customer.id);
        }
    }

    // return unassociated customer ids that needs to be removed
    return idsToRemove;
}


/**
 * I get a whatsapp contact given a supposed one.
 *
 * :param account: whatsapp account uid
 * :param contact: whatsapp contact uid
 *
 * :returns: promise with whatsapp contact or null.
 */
async function getWhatsappContact (
    account: string,
    contact: string,
): Promise<string | null>
{
    // initialize response
    let response: IFetchWhatsappContactResponse;

    // fetch whatsapp contact
    try
    {
        response = await timeout(
            graphis.query(FETCH_WHATSAPP_CONTACT, {account, contact}),
            CONTACTS_TIMEOUT,
        );
    }

    // error fetching whatsapp contact: log and return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // return whatsapp contact
    return response.data.whatsappContact;
}


/**
 * I get the status of a whatsapp contact.
 *
 * :param account: whatsapp account uid
 * :param contact: whatsapp contact uid
 *
 * :returns: promise with status or null.
 */
async function getWhatsappContactStatus (
    account: string,
    contact: string,
): Promise<IWhatsappContactStatusResponse>
{
    // initialize response
    let response: IFetchWhatsappContactStatusResponse;

    // fetch whatsapp contact status
    try
    {
        response = await graphis.query(
            FETCH_WHATSAPP_CONTACT_STATUS,
            {account, contact},
        );
    }

    // request failed: log and return null
    catch (e)
    {
        console.error(e);
        return {
            code: 500,
        };
    }

    // get response data props
    const {status} = response.data;

    // failed: return error code
    if (status.__typename === 'Error')
    {
        return {
            code: Number((status as IGraphisError).code),
        };
    }

    // return status
    return {
        code: 200,
        data: (status as IWhatsappContactStatus),
    };
}


/**
 * I add the correct contact to the customer
 *
 * :param contacts: customer contacts
 * :param uid: correct uid
 * :param username: contact username
 *
 * :returns: reduced contacts
 */
function handleWhatsappMismatch (
    contacts: IContact[],
    uid: string,
    username?: string | null,
): IContact[]
{
    // check whether the uid is already in the contacts
    const alreadyExists = contacts.some(contact => contact.value === uid);

    // contact with uid already exists: return contacts as is
    if (alreadyExists === true)
    {
        return contacts;
    }

    // add correct whatsapp contact
    (contacts as Omit<IContact, 'id'>[]).push({
        displayName: getContactDisplayName('whatsapp', uid, username),
        type_id: contactTypesChannelToId.get('whatsapp'),
        username,
        value: uid,
    });

    // return reduced contacts
    return contacts as IContact[];
}


/**
 * I check if a given contact channel is active.
 *
 * :param contactChannel: contact channel id
 * :param channels: company active channels
 *
 * :returns: whether the contact has an active channel
 */
function isActive (contactChannel: number, channels: string[]): boolean
{
    // get contact channel name
    const channel = contactTypesIdToChannel.get(contactChannel);

    // channel not found: return channel is not active
    if (channel === null || channel === undefined)
    {
        return false;
    }

    // channel found: return whether channel is active or not
    return channels.includes(channel.toLowerCase());
}


/**
 * I check if a given contact channel should be rendered as info.
 *
 * :param contactChannel: contact channel id
 * :param channels: company active channels
 *
 * :returns: whether the contact should be rendered as info
 */
function isInfo (contactChannel: number, channels: string[]): boolean
{
    // get contact channel name
    const channel = contactTypesIdToChannel.get(contactChannel).toLowerCase();

    // return whether channel is info or not
    return channels.includes(channel) === false ||
           channel === 'whatsapp' ||
           channel === 'email';
}


/**
 * I check if a contact is a whatsapp bsuid.
 *
 * :param channel: contact channel
 * :param uid: contact uid
 *
 * :returns: whether the contact is a whatsapp bsuid
 */
function isWhatsappBsuid (channel: string, uid: string): boolean
{
    return channel === 'whatsapp' &&
           uid.endsWith(WHATSAPP_SUFFIX) === false;
}


/**
 * I fetch a customer by id and add it to the state.
 *
 * :param id: customer id
 *
 * :returns: promise with customer or null
 */
async function loadCustomer (id: string | number): Promise<ICustomerData | null>
{
    // initialize customer
    let customer = null;

    // get customer
    customer = customers.fetch(id) ?? null;

    // customer found: return it
    if (customer !== null)
    {
        return customer;
    }

    // customer not found: try to fetch it
    customer = await getCustomer(Number(id));

    // customer not found or invisible to the user: return null
    if (customer === null || isCustomerVisible(customer?.agents) === false)
    {
        return null;
    }

    // customer is visible: add it to state
    await add(
        customer.agents,
        customer.contacts.map(reduceContact),
        customer.id,
        customer.name,
        false,
        customer.address1,
        customer.address2,
        customer.city,
        customer.code,
        customer.description,
        customer.document,
        customer.email,
        customer.organization,
        customer.state,
        customer.tags,
        customer.zipcode,
    );

    // return customer
    return customer;
}


/**
 * I reduce a graphis contact to a customers store contact.
 *
 * :param contact: graphis contact
 *
 * :returns: customers store contact
 */
function reduceContact (contact: IContactData): IContact
{
    return {
        displayName: getContactDisplayName(contact.channel, contact.uid,
                                           contact.username),
        id: contact.id,
        name: contact.name,
        type_id: contactTypesChannelToId.get(contact.channel),
        username: contact.username,
        value: contact.uid,
    };
}


/**
 * I reduce a contact new to a graphis contact patch.
 *
 * :param contact: contact patch
 *
 * :returns: reduced contact
 */
function reduceContactNew (contact: IContactNew): IContactPatch
{
    // get contact properties
    const {id} = contact;
    const {type_id} = contact;
    let {value} = contact;

    // is whatsapp contact and value is a phone number: add suffix
    if (Number(contact.type_id) === 5 && /^\d+$/.test(value) === true)
    {
        value = `${value}${WHATSAPP_SUFFIX}`;
    }

    // return reduced contact
    return {
        channel: contactTypesIdToChannel.get(Number(type_id))?.toLowerCase(),
        id,
        uid: value,
    };
}


/**
 * I reduce a state customer to a graphis customer patch.
 *
 * :param customer: customer to be reduced
 * :param added: contacts to be added
 *
 * :returns: reduced customer
 */
const reduceCustomer = (customer: ICustomer,
                        added: IContact[]): ICustomerPatch =>
{
    const {agents} = customer;
    const {contacts} = customer;

    // reduce agents
    const reducedAgents: string[] = agents.map(
        ({uid}: ICustomerAgent): string => uid,
    );

    // reduce contacts
    const reducedContacts: IContactPatch[] = contacts.map(reduceContactNew);

    // add the contacts the customer does not have yet
    added.forEach(contact =>
    {
        // reduce the contact without its store built id, unknown to clientis
        const reduced = reduceContactNew({
            type_id: contact.type_id,
            value: contact.value,
        });

        // customer already has the contact: keep the list as is
        if (reducedContacts.some(held => held.uid === reduced.uid) === true)
        {
            return;
        }

        // add the contact to the list
        reducedContacts.push(reduced);
    });

    // return reduced customer
    return {
        address1: customer.address1,
        address2: customer.address2,
        agents: reducedAgents,
        city: customer.city,
        code: customer.code,
        company: customer.company,
        contacts: reducedContacts,
        description: customer.description,
        document: customer.document,
        name: customer.name,
        organization: customer.organization,
        state: customer.state,
        zipcode: customer.zipcode,
    };
};


/**
 * I remove a customer with given id.
 *
 * :param id: customer id
 *
 * :returns: promise with number or null
 */
const removeCustomer = async (id: number): Promise<number | null> =>
{
    // initialize response
    let response: IRemoveCustomerResponse;

    // set mutation variables
    const variables: IRemoveCustomerVariables = {id};

    // remove customer
    try
    {
        response = await graphis.mutate(REMOVE_CUSTOMER, variables);
    }

    // remove customer failed: log and return customer not removed event
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // return customer id from result
    return response.data.removeCustomer;
};


/**
 * I tag a customer.
 *
 * :param customer: customer id
 * :param tag: tag id
 *
 * :returns: promise with tag customer association or null
 */
async function tagCustomer(
    customer: number,
    tag: number,
): Promise<ICustomerTag | null>
{
    // initialize response
    let response: ITagCustomerResponse;

    // set mutation variables
    const variables: ITagCustomerVariables = {
        customer,
        tag,
    };

    // tag customer
    try
    {
        response = await graphis.mutate(TAG_CUSTOMER, variables);
    }

    // tag customer failed: log and return
    catch (e)
    {
        console.error(e);
        return null;
    }

    // tag customer success: return customer tag associaton
    return response.data.tagCustomer;
}


/**
 * I indicate whether customer is visible to user.
 *
 * :param agents: customer agents
 *
 * :returns: whether customer is visible to user
 */
function isCustomerVisible(agents: ICustomerAgent[]): boolean
{
    // get company config
    const config = getCompanyConfig();

    // company config not loaded: return false
    if (config === null)
    {
        return false;
    }

    // get company visibility config
    const visibility = config.visibility.customers;

    // get logged user
    const user = fetch();

    // user is admin: all customers are visible
    if (user.isAdmin === true)
    {
        return true;
    }

    // customer in no wallet: return whether no-wallet customers are visible
    if (agents.length === 0)
    {
        return visibility.noWallet;
    }

    // customer in wallet and only user-owned customers are visible: check it
    if (visibility.onlyOwn === true)
    {
        return agents.some(agent => agent.uid === user.id);
    }

    // customers in any wallet are visible: return true
    return true;
}


/**
 * I unblock a whatsapp contact.
 *
 * :param account: whatsapp account uid
 * :param contactUid: contact uid
 *
 * :returns: error message or null (success)
 */
async function unblockWhatsappContact(
    account: string,
    contact: string,
): Promise<string | null>
{
    // initialize response
    let response: IUnblockWhatsappContactResponse;

    // try unblock whatsapp contact
    try
    {
        response = await graphis.mutate(
            UNBLOCK_WHATSAPP_CONTACT,
            {account, contact},
        );
    }

    // request failed: log and fail with unknown reason
    catch (error)
    {
        // get user info
        const {company, id: user} = fetch();

        // log and return unknown reason
        logger.error('CVJPZ0069E', {
            company,
            contact,
            reason: error,
            user,
        });
        return 'unknown';
    }

    // get response data props
    const {unblockWhatsappContact} = response.data;

    // success: return null
    if (unblockWhatsappContact?.__typename === 'UnblockWhatsappContact')
    {
        return null;
    }

    // fail with graphis error: return it or fallback
    return (unblockWhatsappContact as IGraphisError)?.code ?? 'unknown';
}


/**
 * I untag a customer.
 *
 * :param customerTag: customer tag association id
 *
 * :returns: promise with tag number or null
 */
async function untagCustomer(customerTag: number): Promise<ICustomerTag | null>
{
    // initialize response
    let response: IUntagCustomerResponse;

    // set mutation variables
    const variables: IUntagCustomerVariables = {
        id: customerTag,
    };

    // untag customer
    try
    {
        response = await graphis.mutate(UNTAG_CUSTOMER, variables);
    }

    // untag customer failed: log and return
    catch (e)
    {
        console.error(e);
        return null;
    }

    // untag customer success: return customer tag association id
    return response.data.untagCustomer;
}


/**
 * I update a customer.
 *
 * :param address1: customer address1
 * :param address2: customer address2
 * :param agents: customer agents
 * :param city: customer city
 * :param code: customer code
 * :param company: customer company
 * :param contacts: customer contacts
 * :param document: customer document
 * :param email: customer email
 * :param id: customer id
 * :param name: customer name
 * :param description: customer description
 * :param organization: customer organization
 * :param state: customer state
 * :param zipcode: customer zipcode
 *
 * :returns: promise with customer or null
 */
async function updateCustomer (
    address1: string,
    address2: string,
    agents: string[],
    city: string,
    code: string,
    company: number,
    contacts: IContactPatch[],
    document: string,
    id: number,
    name: string,
    description: string,
    organization: string,
    state: string,
    zipcode: string,
): Promise<ICustomer | null>
{
    // set mutation variables
    const variables = {
        patch: {
            address1,
            address2,
            agents,
            city,
            code,
            company,
            contacts,
            description,
            document,
            id,
            name,
            organization,
            state,
            zipcode,
        },
    };

    // initialize result
    let result;

    // update customer
    try
    {
        result = await graphis.mutate(UPDATE_CUSTOMER, variables);
    }

    // update customer failed: return null
    catch (e)
    {
        console.error(e); // eslint-disable-line no-console
        return null;
    }

    // get updated customer from result data
    const {updateCustomer} = result.data;

    // update customer refused: return null
    if (updateCustomer === null)
    {
        return null;
    }

    // update contacts to expected format
    const updatedContacts = updateCustomer.contacts.map(reduceContact);

    // return customer
    return {...updateCustomer, contacts: updatedContacts};
}


/**
 * I validate whatsapp contacts.
 *
 * :param contacts: contacts list
 *
 * :returns: promise with valid contacts
 */
async function validateWhatsappContacts (
    contacts: IContactPatch[],
): Promise<IContactPatch[]>
{
    // update contact value from whatsapp contacts
    const updatedContacts: IContactPatch[] = [];

    // no whatsapp active accounts: return unchanged contacts
    if (accountsSelectors.getAllByChannel('whatsapp').length === 0)
    {
        return contacts;
    }

    // update contacts of whatsapp type
    for (const contact of contacts)
    {
        // get contact props
        const {channel, id, uid} = contact;

        // not a whatsapp contact: keep it unchanged and skip
        if (channel !== 'whatsapp')
        {
            updatedContacts.push(contact);
            continue;
        }

        // contact already exists: keep it unchanged and skip
        if (id !== undefined && id !== null)
        {
            updatedContacts.push(contact);
            continue;
        }

        // get real whatsapp contact uid
        const realUid = await checkWhatsappContact(uid);

        // push contact
        updatedContacts.push({...contact, uid: realUid ?? uid});
    }

    // return updated contacts
    return updatedContacts;
}


/**
 * EXPORTS
 */
export {
    CLIENTIS_ORIGIN,
    CONVERSIS_ORIGIN,
    addAssociatedCustomer,
    addUnassociatedCustomer,
    blockWhatsappContact,
    contactTypesChannelToId,
    contactTypesIdToChannel,
    checkWhatsappContact,
    copyUidAvailable,
    createCustomer,
    ensureCustomer,
    ensureUniqueContact,
    fetchCustomerByContact,
    getAlternativeWhatsappUid,
    getBsuid,
    getBsuidsByUid,
    getContactDisplayName,
    getContactsFromPhone,
    getContactTypes,
    getCustomer,
    getCustomers,
    getCustomersByCompany,
    getCustomersByTagPage,
    getCustomersByTags,
    getCustomersPage,
    getEightDigitWhatsappUid,
    getMappedContactUids,
    getPhoneVariants,
    getUnassociatedCustomerName,
    getUnassociatedCustomersToBeAdded,
    getUnassociatedCustomersToBeRemoved,
    getWhatsappContact,
    getWhatsappContactStatus,
    handleWhatsappMismatch,
    isActive,
    isCustomerVisible,
    isInfo,
    isWhatsappBsuid,
    loadCustomer,
    mergeMappedContacts,
    reduceContact,
    reduceContactNew,
    reduceCustomer,
    removeCustomer,
    syncBsuidsWithPhones,
    searchContacts,
    searchConversationContacts,
    tagCustomer,
    unblockWhatsappContact,
    untagCustomer,
    updateCustomer,
    validateWhatsappContacts,
};
